import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
// import { updateAvailableBalance, updateExposureBalance } from "../redux/slices/userSlice";
import { placeBet as handleBetSave } from "../../../socketClient";
import { updateAvailableBalance, updateExposureBalance } from "../../../AsianExchangeSrc/redux/slices/userSlice";

export const eventsData = [
    {
        eventTypeId: "4",
        name: "Cricket",
    },
    {
        eventTypeId: "1",
        name: "Soccer",
    },
    {
        eventTypeId: "2",
        name: "Tennis",
    },
];

function generateSingleCashoutBet(filteredBets, runners, odds) {
    if (!filteredBets?.length || !runners?.length || !odds?.length) return null;

    const runnerPnL = new Map();
    runners.forEach(runner => {
        runnerPnL.set(Number(runner.selectionId), 0);
    });

    // Step 1: Calculate current PnL for each runner
    filteredBets.forEach(({ selectionId, type, favourMargin, againstMargin }) => {
        const selId = Number(selectionId);

        runners.forEach(({ selectionId: rId }) => {
            const runnerId = Number(rId);

            if (runnerId === selId) {
                if (type === "Back") {
                    runnerPnL.set(runnerId, runnerPnL.get(runnerId) + Number(favourMargin));
                } else {
                    runnerPnL.set(runnerId, runnerPnL.get(runnerId) - Number(againstMargin));
                }
            } else {
                if (type === "Back") {
                    runnerPnL.set(runnerId, runnerPnL.get(runnerId) - Number(againstMargin));
                } else {
                    runnerPnL.set(runnerId, runnerPnL.get(runnerId) + Number(favourMargin));
                }
            }
        });
    });

    let bestOffer = null;
    let lowestSpread = Infinity;

    for (const runner of odds) {
        const selectionId = Number(runner.selectionId);
        const matchedRunner = runners.find(r => Number(r.selectionId) === selectionId);
        if (!matchedRunner) continue;

        const runnerName = matchedRunner.runnerName;
        const backOdds = runner.ex?.availableToBack?.[0]?.price;
        const layOdds = runner.ex?.availableToLay?.[0]?.price;

        if (!backOdds || !layOdds || backOdds < 1.01 || layOdds < 1.01) continue;

        for (const betType of ["Back", "Lay"]) {
            const oddsToUse = betType === "Back" ? backOdds : layOdds;

            // Start a binary-like search for stake
            let low = 0;
            let high = 100000;
            let bestStake = 0;
            let iterations = 0;

            while (iterations < 100) {
                const stake = (low + high) / 2;

                const tempPnl = new Map(runnerPnL);
                runners.forEach(({ selectionId: rId }) => {
                    const rIdNum = Number(rId);
                    if (rIdNum === selectionId) {
                        if (betType === "Back") {
                            tempPnl.set(rIdNum, tempPnl.get(rIdNum) + stake * (oddsToUse - 1));
                        } else {
                            tempPnl.set(rIdNum, tempPnl.get(rIdNum) - stake * (oddsToUse - 1));
                        }
                    } else {
                        if (betType === "Back") {
                            tempPnl.set(rIdNum, tempPnl.get(rIdNum) - stake);
                        } else {
                            tempPnl.set(rIdNum, tempPnl.get(rIdNum) + stake);
                        }
                    }
                });

                const values = Array.from(tempPnl.values());
                const max = Math.max(...values);
                const min = Math.min(...values);
                const spread = max - min;

                if (spread < 0.01) {
                    bestStake = stake;
                    break;
                }

                if (spread < lowestSpread) {
                    lowestSpread = spread;
                    bestStake = stake;
                }

                // Adjust bounds
                const avg = values.reduce((a, b) => a + b, 0) / values.length;
                if (tempPnl.get(selectionId) > avg) {
                    high = stake;
                } else {
                    low = stake;
                }

                iterations++;
            }

            if (bestStake > 0 && isFinite(bestStake)) {
                bestOffer = {
                    selectionId,
                    selectionName: runnerName,
                    betType,
                    odds: oddsToUse,
                    stake: parseFloat(bestStake.toFixed(2)),
                    favourMargin: betType === "Back" ? (oddsToUse - 1) * bestStake : bestStake,
                    againstMargin: betType === "Back" ? bestStake : (oddsToUse - 1) * bestStake,
                    reason: "Exact flatten cashout",
                    runner
                };
            }
        }
    }

    return bestOffer?.stake > 0 ? bestOffer : null;
}



function findMaxLoss(filteredBets, cashoutOffer, runners) {
    function computeMaxLoss(bets, runners) {
        const runnersPnl = {};

        runners.forEach(({ selectionId: runnerId }) => {
            bets.forEach(({ selectionId, type, favourMargin, againstMargin }) => {
                if (runnerId == selectionId) {
                    if (type === "Back") {
                        runnersPnl[selectionId] = (runnersPnl?.[selectionId] || 0) + favourMargin;
                    }
                    if (type === "Lay") {
                        runnersPnl[selectionId] = (runnersPnl?.[selectionId] || 0) - againstMargin;
                    }
                } else {
                    if (type === "Back") {
                        runnersPnl[runnerId] = (runnersPnl?.[runnerId] || 0) - againstMargin;
                    }
                    if (type === "Lay") {
                        runnersPnl[runnerId] = (runnersPnl?.[runnerId] || 0) + favourMargin;
                    }
                }
            });
        });

        const pnlValues = Object.values(runnersPnl);
        return Math.min(...pnlValues);
    }

    const maxLossWithoutCashout = computeMaxLoss(filteredBets, runners);
    const maxLossWithCashout = computeMaxLoss([...filteredBets, cashoutOffer], runners);

    return {
        maxLossWithoutCashout: maxLossWithoutCashout,
        maxLossWithCashout: maxLossWithCashout,
    };
}

export const getSportNameById = (sportId) => {
    const events = eventsData;
    const currentEvent = events.find(e => e.eventTypeId === sportId)
    if (currentEvent) {
        return currentEvent.name
    }
    return ""
}

const CashOutAura = ({ marketId, filteredBets, runningData, odds, eventId, legueId, matchId, event, markettype, market, sportName, DisMarketName, 
 }) => {

    const dispatch = useDispatch();

    const userBalance = useSelector(state => {
        const { availableBalance, bonusBalance, exposure } = state.user.userData || { availableBalance: 0, bonusBalance: 0, exposure: 0 };
        return Number(availableBalance + bonusBalance - exposure)
    });

    const [cashoutOffer, setCashoutOffer] = useState(null);
    const [placeBet, setPlaceBet] = useState(false);
    const [cashoutValue, setCashoutValue] = useState(null);
    const [isPlacingBet, setIsPlacingBet] = useState(false);

    useEffect(() => {
        if (placeBet) {
            const timer = setTimeout(() => {
                setPlaceBet(false);
                setCashoutOffer(null);
            }, 10000); // 10 seconds

            return () => clearTimeout(timer); // Cleanup function to prevent memory leaks
        }
    }, [placeBet]);

    const handleCashout = async () => {
        if (filteredBets?.length === 0) {
            toast.info("Please place bet first");
            setPlaceBet(false)
            return;
        }
        if (placeBet && cashoutOffer) {
            if ((cashoutOffer && cashoutOffer.stake === 0)) {
                setPlaceBet(false)
                const toastId = "cashout-info-1";

                if (!toast.isActive(toastId)) {
                    toast.info("Cashout not possible right now.", { toastId });
                }

                return;
            }
            setIsPlacingBet(true)
            const betData = {
                ...cashoutOffer,
                sportsName: sportName,
                eventId,
                legueId,
                matchId,
                selection: cashoutOffer.selectionName || cashoutOffer.runner.runner,
                event,
                markettype,
                market,
                oddsReq: cashoutOffer.odds,
                marketId,
                runners: runningData,
                placeTime: new Date().toISOString(),
                isCashout: true,

            }

            // await handleBetSave(betData);
            // setCurrentOddsBetData([...filteredBets, { ...betData }]);

            try {


                // setLoading(true);
                const createResponse = await handleBetSave(betData)


                if (!createResponse.success) {
                    toast.warning(createResponse.message);
                    return;
                }
                setPlaceBet(false)
                toast.success("Cashed out successfully!");
                // handleCancelClick();
                dispatch(updateAvailableBalance(createResponse?.userData?.availableBalance));
                dispatch(updateExposureBalance(createResponse?.exposure));
                

            } catch (error) {
                console.error("Error placing bet:", error.message);
                toast.error("Failed to place bet");
            } finally {
                setIsPlacingBet(false);
                setCashoutOffer(null)
                setPlaceBet(false);

            }


        } else {
            setPlaceBet(true);
        }
    };

    useEffect(() => {
        if (filteredBets?.length > 0 && placeBet) {
            const offer = generateSingleCashoutBet(filteredBets, runningData, odds);
            if (!offer) {
                // const toastId = "cashout-info-2";

                // if (!toast.isActive(toastId)) {
                //     toast.info("No cashout offer available.", { toastId });
                // }
                setPlaceBet(false)
                return;
            }
            if (userBalance < offer?.stake && !(userBalance <= 0)) {
                offer.stake = userBalance;
                offer.favourMargin = offer?.betType === "Back" && offer?.odds > 1 ? (offer?.odds - 1) * offer?.stake : offer?.stake;
                offer.againstMargin = offer?.betType === "Back" && offer?.odds > 1 ? offer?.stake : (offer?.odds - 1) * offer?.stake;
            }
            offer.type = offer?.betType;
            // setPlaceBet(false)
            setCashoutOffer(offer);
        }
    }, [filteredBets, runningData, odds, placeBet]);

    useEffect(() => {
        if (filteredBets?.length > 0 && cashoutOffer && cashoutOffer.stake <= userBalance && cashoutOffer.stake > 0) {
            const { maxLossWithCashout, maxLossWithoutCashout } = findMaxLoss(filteredBets, cashoutOffer, runningData);

            if (maxLossWithCashout > maxLossWithoutCashout) {

                setCashoutValue(maxLossWithCashout);
            }
            else {
                setCashoutValue(null)
                // toast.info("Cashout not possible right now.");
                const toastId = "cashout-info-1";

                if (!toast.isActive(toastId)) {
                    toast.info("Cashout not possible right now.", { toastId });
                }
                setPlaceBet(false)
            }
        }
    }, [cashoutOffer]);



    return (



        <button
            disabled={filteredBets?.length === 0}
            onClick={handleCashout}
            className={`relative ml-2 flex flex-row items-center gap-1 px-2 py-1 rounded-sm shadow-md transition-all duration-300 ease-in-out
                            ${filteredBets?.length === 0
                    ? "bg-gray-900 cursor-not-allowed text-black opacity-70"
                    : "bg-black text-black hover:shadow-lg hover:scale-105 active:scale-95"
                }`}
        >
            {/* Indicator Circle */}
            {/* <div
                className={`w-3 h-3 flex items-center justify-center shadow-sm p-1
                                 ${placeBet && cashoutValue ? "bg-green-300 text-green-800" : "bg-amber-400 text-black"}`}
            >
                <p className="text-sm leading-none">{placeBet ? (cashoutValue ? "✓" : "x") : "●"}</p>
            </div> */}
            <div className="w-[10px] h-[10px] flex flex-row justify-center items-center mt-[-2.5px] text-amber-400 leading-none text-center">
                <p>{placeBet ? (cashoutValue ? "✓" : "x") : "●"}</p>
                
            </div>
            {/* Button Label */}
            <div className="h-[10px] text-[10px] font-semibold tracking-wide text-amber-400 leading-none">
                {placeBet && cashoutValue ? cashoutValue.toFixed(0) : "Cashout"}
            </div>

            {/* Optional Loading Spinner */}
            {isPlacingBet && (
                <div className="ml-2 w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            )}
        </button>

    );
};

export default CashOutAura;
